<template>
	<div class="result_big">
		<div class="res_box">
			<img style="height:64px;width:64px;margin-right:24px" src="../../assets/img/Shape.png"/>
			<div>
				<p style="color:#0A1132;font-size:20px">恭喜你，兑换成功</p>
				<!-- <p style="margin-top:16px;margin-bottom:32px;color:#5B5D66">收货信息：{{address.consignee}} {{address.mobile}} {{address.province}}{{address.city}}{{address.district}}{{address.town}}{{address.detail}}</p> -->
				<div style="margin-top:20px;">
					<el-button style="height：42px;width:144px;background:#F3A251;color:white;" @click="bindorder">查看兑换详情</el-button>
		    		<el-button style="height：42px;width:144px;" @click="bindfh">返回首页</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import nav from '../nav';
	import getCurrentCityName from '../../js/map'
	import links from '../../js/link_parameters';
	import wechatAuth from '../../wechatAuth'
	import { Message, Loading } from 'element-ui';
	import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
	import Vue from 'vue'
	import $ from 'jquery'
	import axios from 'axios';
	import Tables from '../../components/tables/tables'
	import echarts from 'echarts'
	import {formatDate,formatTimeToStr} from '../../js/data'
	export default {
		name: 'index',
		components: {
			Tables
		},
		data() {
			var vm = this
			return {
				orderid:this.$route.query.id?this.$route.query.id:"",
				ordername:this.$route.query.name?this.$route.query.name:"",
				address:''
			}
		},
		computed: {},
		created() {},
		mounted() {
			
			var user = sessionStorage.getItem("user")
			var address = sessionStorage.getItem("address")
			if(address){
				this.address= JSON.parse(address)
			}
			if(user){
				this.user = JSON.parse(user)
			}else{
				this.$router.push({path:'/login'})
			}
			console.log(axios.defaults.baseURL)
			if (window.history && window.history.pushState) {
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.goBack, false);
			}
			this.bindcard()
			this.getUser()
		},
		destroyed(){
			window.removeEventListener('popstate', this.goBack, false);
		},
		methods: {
			bindcard(){
				var cart_list = localStorage.getItem("cart_list");
				var sp_list = cart_list?JSON.parse(cart_list):[]
				var list = []
				sp_list.forEach((item)=>{
					if(!item.show){
						list.push(item)
					}
				})
				localStorage.setItem("cart_list",JSON.stringify(list))
			},
			getUser(e){
				var headers = {
								'Content-Type':'application/x-www-form-urlencoded',
								'Authorization': this.user.token
							}
						this.$server.getCardUserBalance({},headers).then(res => {
							console.log(res)
							if(res.code==0){
					var user = this.user;
					this.$store.state.validTimes = res.data.default.validTimes;
					this.$store.state.balance = res.data.default.balance;
					sessionStorage.setItem("user", JSON.stringify(user));
					if(e){
					res.data.default.show=true
					this.card_list.push(res.data.default)
					this.confirm_k_list.push(res.data.default)
					console.log('this.confirm_k_list',this.confirm_k_list)
					}
					// this.createpays()
				}
				console.log('卡list',this.card_list)
				})
			},
			goBack(){
				this.$router.replace({path: '/'});
				//replace替换原路由，作用是避免回退死循环
			},
			bindfh(){
				this.$router.push({path:'/'})
			},
			bindorder(){
				this.$router.push({path:'/order_detail',query: {id:this.orderid,name:this.ordername}})
			}
		},
		computed: {}
	}
</script>

<style lang="scss" scoped>
.result_big{
	min-height:87vh;
	border-top:1px solid #E4E5ED;
	.res_box{
		width:1260px;
		margin:32px auto;
		height:282px;
		display: flex;
		padding:72px;
		border:1px solid #E6E6E6;
	}
}
</style>